import Game from "./scripts/game.js"

document.addEventListener("DOMContentLoaded", () => {
    const game1 = new Game();
})

